export default class ItemsSelection {
    constructor(gudhub) {
        this.gudhub = gudhub;
        this.selectedItems = {}
    }

    async selectItems(appId, items) {
        if(!this.selectedItems.hasOwnProperty(appId)) {
            this.selectedItems[appId] = {
                items: [],
                app: []
            }

            let app = await this.gudhub.getApp(appId);
            this.selectedItems[appId].app = app;
        }

        let itemObject = this.selectedItems[appId];

        let selectedItemsIds = itemObject.items.map(obj => obj.item_id);

        items.forEach(item => {
            if(selectedItemsIds.indexOf(item.item_id) != -1) {
                itemObject.items.splice(selectedItemsIds.indexOf(item.item_id), 1);
            } else {
                itemObject.items[itemObject.items.length] = item;
            }
        });

    }

    getSelectedItems(appId) {
        return this.selectedItems[appId] ? this.selectedItems[appId] : { items: [], app: [] };
    }

    clearSelectedItems(appId) {
        if(this.selectedItems[appId]) {
            this.selectedItems[appId].items = [];
        }
    }

    isItemSelected(appId, itemId) {
        let array = this.getSelectedItems(appId);
        if(array !== null) {
            array = array.items.map(obj => obj.item_id);
            return array.indexOf(itemId) != -1;
        } else {
            return false;
        }
    }

}